import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postUpdateStockURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
  } from "@chakra-ui/react";

function EditStock({
    isOpen,
    onClose,
    successCallback,
    stockData,
}) {

    const [ supplier, setSupplier ] = useState('');
    const [ quantity, setQuantity ] = useState("0");
    const [ unitPrice, setUnitPrice ] = useState("0.0");
    const [ sellingPrice, setSellingPrice ] = useState("0.0");

    const [ invSupplier, setInvSupplier ] = useState(null);
    const [ invQuantity, setInvQuantity ] = useState(null);
    const [ invUnitPrice, setInvUnitPrice ] = useState(null);
    const [ invSellingPrice, setInvSellingPrice ] = useState(null);


    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postStocks = (e) => {
        e.preventDefault();

        let id;
        if (stockData) {
            id = stockData.id;
        } 

        setSubmitting(true);
        setErrors([]);
        // console.log(stock, price);
        axios.post(postUpdateStockURL(id), {
            supplier,
            quantity,
            unitPrice,
            sellingPrice,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (!validator.isEmpty(quantity.toString())) {
            setInvQuantity(!validator.isInt(quantity));
        }

        if (!validator.isEmpty(unitPrice.toString())) {
            setInvUnitPrice(!validator.isNumeric(unitPrice));
        }

        if (!validator.isEmpty(sellingPrice.toString())) {
            setInvSellingPrice(!validator.isNumeric(sellingPrice));
        }

        if (!validator.isEmpty(supplier)) {
            setInvSupplier(supplier.length < 1);
        }


    }, [supplier, quantity, unitPrice, sellingPrice]);


    useEffect(() => {

        if (stockData) {
            // console.log(stockData);
            setSupplier(stockData.supplier);
            setQuantity(stockData.quantity);
            setUnitPrice(stockData.unitPrice);
            setSellingPrice(stockData.sellingPrice);
        }

    }, [stockData]);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Edit Stock</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postStocks}>
                    <FormControl >
                        
                    <Box pr="12px">
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Stock Supplier
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="Stock Supplier"
                            size="md" 
                            isInvalid={invSupplier === true}
                            isRequired={true}
                            value={supplier} 
                            onChange={e => setSupplier(e.target.value)}
                        />
                    </Box>
                
                    <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                        Quanity
                    </FormLabel>
                    <Input
                        borderRadius="15px"
                        mb="12px"
                        fontSize="sm"
                        type="text"
                        placeholder="Enter Quanity"
                        size="md" 
                        isInvalid={invQuantity === true}
                        isRequired={true}
                        value={quantity} 
                        onChange={e => setQuantity(e.target.value)}
                    />


                    <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                        Unit Price
                    </FormLabel>
                    <Input
                        borderRadius="15px"
                        mb="12px"
                        fontSize="sm"
                        type="text"
                        placeholder="Enter Unit Price"
                        size="md" 
                        isInvalid={invUnitPrice === true}
                        isRequired={true}
                        value={unitPrice} 
                        onChange={e => setUnitPrice(e.target.value)}
                    />


                    <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                        Selling Price
                    </FormLabel>
                    <Input
                        borderRadius="15px"
                        mb="12px"
                        fontSize="sm"
                        type="text"
                        placeholder="Enter Selling Price"
                        size="md" 
                        isInvalid={invSellingPrice === true}
                        isRequired={true}
                        value={sellingPrice} 
                        onChange={e => setSellingPrice(e.target.value)}
                    />

                    <Flex w="100%" flexDir="column">
                        { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                    </Flex>
                    <Button
                        fontSize="10px"
                        type="submit"
                        bg="teal.300"
                        w="100%"
                        h="45"
                        mb="20px"
                        color="white"
                        mt="0px"
                        _hover={{
                        bg: "teal.200",
                        }}
                        _active={{
                        bg: "teal.400",
                        }}
                        isDisabled={submitting}
                    >
                        SUBMIT
                    </Button>
                </FormControl>
            </form>
            </ModalBody>
            {/* <ModalFooter>
                <Flex w="100%"
                flexDirection={{
                sm: "row",
                md: "row",
                }} 
                alignItems={{ xl: "center" }}>
                <Button variant="ghost" onClick={onClose}>Cancel</Button>
                <Spacer />
                <Button colorScheme="teal" mr={3} >
                    Submit
                </Button>
                </Flex>
            </ModalFooter> */}
            </ModalContent>
        </Modal>
    );

}



export default EditStock;
